

const MovieApi = [
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/5658/1175658-v-c61b83f58fb8",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"MoonLight",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/8723/1078723-v-a1a04c7474f9",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/5162/875162-v",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m ",
        name:"Avengers-END GAME",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/4396/1444396-v-a381e9f2895e",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"The Bad Batch",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/4669/674669-v",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Beauty and The Beast",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/5150/875150-v",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Aladin",
    },

    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/3639/1433639-v-4667d2acb4c6",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/6462/1436462-v-e688776a6e16",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/5162/875162-v",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/9157/1429157-v-c0a5806446c1",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_1_5x/sources/r1/cms/prod/2974/1412974-v-6b0c211e8292",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/8475/1408475-v-6e786e852f71",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/5658/1175658-v-c61b83f58fb8",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"MoonLight",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/8723/1078723-v-a1a04c7474f9",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/5162/875162-v",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m ",
        name:"Avengers-END GAME",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/4396/1444396-v-a381e9f2895e",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"The Bad Batch",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/4669/674669-v",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Beauty and The Beast",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/5150/875150-v",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Aladin",
    },

    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/3639/1433639-v-4667d2acb4c6",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/6462/1436462-v-e688776a6e16",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/5162/875162-v",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/9157/1429157-v-c0a5806446c1",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_1_5x/sources/r1/cms/prod/2974/1412974-v-6b0c211e8292",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/8475/1408475-v-6e786e852f71",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/5658/1175658-v-c61b83f58fb8",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"MoonLight",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/8723/1078723-v-a1a04c7474f9",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/5162/875162-v",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m ",
        name:"Avengers-END GAME",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/4396/1444396-v-a381e9f2895e",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"The Bad Batch",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/4669/674669-v",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Beauty and The Beast",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/5150/875150-v",
        des:"It is a nice movie to watch i hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Aladin",
    },

    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/3639/1433639-v-4667d2acb4c6",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/6462/1436462-v-e688776a6e16",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/5162/875162-v",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/9157/1429157-v-c0a5806446c1",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_1_5x/sources/r1/cms/prod/2974/1412974-v-6b0c211e8292",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/8475/1408475-v-6e786e852f71",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
   
   
]

export default MovieApi;